//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
// eslint-disable-next-line object-curly-newline
import { mdiEmailOutline, mdiChartTimelineVariant, mdiArrowDown, mdiTrendingUp } from '@mdi/js'

export default {
  setup() {
    const selected = ref([])
    const chipColor = {
      Paid: 'success',
      Unpaid: 'error',
    }

    const tableColumnHeaders = [
      {
        text: '#ID',
        align: 'start',
        value: 'id',
      },
      { text: 'Status', value: 'status' },
      { text: 'CLIENT', value: 'client' },
      { text: 'TOTAL', value: 'total' },
      { text: 'BALANCE', value: 'balance' },
    ]

    const userlist = [
      {
        id: '#2798',
        status: mdiEmailOutline,
        statusColor: 'primary',
        avatar: '1.png',
        avatarColor: 'primary',
        fullName: 'Joseph Wheeler',
        email: 'ciakgu@geawo.gov',
        total: 277.39,
        balance: 459,
      },
      {
        id: '#1304',
        status: mdiChartTimelineVariant,
        statusColor: 'warning',
        avatar: '2.png',
        avatarColor: 'primary',
        fullName: 'May Lloyd',
        email: 'nofbek@zu.org',
        total: 117.58,
        balance: 'Paid',
      },
      {
        id: '#7900',
        status: mdiChartTimelineVariant,
        statusColor: 'warning',
        avatar: '3.png',
        avatarColor: 'primary',
        fullName: 'William Mckinney',
        email: 'cidagehe@nonaloobo.com',
        total: 1792,
        balance: 'Unpaid',
      },
      {
        id: '#63036',
        status: mdiArrowDown,
        statusColor: 'info',
        avatarColor: 'primary',
        fullName: 'Isabel Briggs',
        email: 'wafe@wavkes.net',
        total: 632.82,
        balance: 'Unpaid',
      },
      {
        id: '#33052',
        status: mdiEmailOutline,
        statusColor: 'primary',
        avatar: '5.png',
        avatarColor: 'primary',
        fullName: 'Warren Clarke',
        email: 'tabigzi@nep.net',
        total: 356.42,
        balance: 899,
      },
      {
        id: '#23579',
        status: mdiArrowDown,
        statusColor: 'info',
        avatar: '4.png',
        avatarColor: 'primary',
        fullName: 'Adeline Bennett',
        email: 'haurvu@wiendo.org',
        total: 289.9,
        balance: 'Unpaid',
      },
      {
        id: '#81618',
        status: mdiChartTimelineVariant,
        statusColor: 'warning',
        fullName: 'Abbie Webster',
        avatarColor: 'success',
        email: 'noj@ej.org',
        total: 2282,
        balance: 'Paid',
      },
    ]

    return {
      selected,
      tableColumnHeaders,
      userlist,
      chipColor,
      icons: {
        mdiTrendingUp,
      },
    }
  },
}
